import React from 'react';

export type AppearanceTypes = 'error' | 'info' | 'normal' | 'success' | 'warning';
export type NotificationType = 'error' | 'info' | 'success' | 'warning';
export type Id = string;
export type Callback = (id: Id) => void;
export type Options = {
  id?: Id;
  type?: NotificationType;
  actions?: never[];
  autoDismiss?: boolean;
  onDismiss?: Callback;
  duration?: number;
};

export type ShowFn = (title: React.ReactNode, description?: React.ReactNode, options?: Options) => Id;
export type UpdateFn = (id: Id, options: Options) => void;
export type RemoveFn = (id: Id) => void;

export type HoverFn = () => void;
//
// export type Placement =
//   | 'bottom-left'
//   | 'bottom-center'
//   | 'bottom-right'
//   | 'top-left'
//   | 'top-center'
//   | 'top-right';

type Noop = () => void;
export const noop: Noop = () => {};

export type Notification = Options & { type: NotificationType, description?: React.ReactNode, title: React.ReactNode, id: Id };
export type Notifications = Array<Notification>;
